import React, { useEffect, useState } from 'react'
import { LoadAllMember } from '../../actions/Members/MemberAction';
import { LoadAllMessage } from '../../actions/Messages/MessageAction';
import { LoadAllTemoignage } from '../../actions/Temoignages/TemoignageAction';
import { LoadAllUser } from '../../actions/Users/UserAction';
import AllRoutes from '../../nametitle/AllRoutes';
import { AiFillSetting } from "react-icons/ai";
import { FaComments, FaRegUserCircle, FaUserSecret, FaUsers } from "react-icons/fa";
import { BsMessenger } from "react-icons/bs";
import { MdAlternateEmail, MdCardTravel, MdInsertEmoticon } from "react-icons/md";
import { TfiDashboard } from "react-icons/tfi"
import { LoadAllEmail } from '../../actions/Emails/EmailsAction';
import { Localvalue } from '../../nametitle/localValue';
import { BiExit } from "react-icons/bi";
import { DiconnectUser } from '../../actions/Autentificate/AuthAction';
import { LoadAllComment } from '../../actions/Comments/CommentAction';
import { LoadAllFideles } from '../../actions/Fideles/FideleAction';


const SidebarAdmin = () => {

    var id = localStorage.getItem(Localvalue.idlogin);

    const [userlist, setuserlist] = useState([]);
    const [emaillist, setemaillist] = useState([])
    const [messageslist, setmessageslist] = useState([]);
    const [memberslist, setmemberslist] = useState([]);
    const [temoignagelist, settemoignagelist] = useState([]);
    const [fidelesList, setfidelesList] = useState([]);
    const [temoignagelistSearch, settemoignagelistSearch] = useState([]);
    const [commentlist, setcommentlist] = useState([]);

    useEffect(() => {
        LoadAllMessage(setmessageslist);
        LoadAllMember(setmemberslist);
        LoadAllUser(setuserlist);
        LoadAllTemoignage(settemoignagelist, settemoignagelistSearch);
        LoadAllEmail(setemaillist);
        LoadAllComment(setcommentlist);
        LoadAllFideles(setfidelesList);
    }, [])



    return (
        <div className="sticky top-0 left-0 z-50  h-screen bg-gray-900">
            <div className=" w-full h-screen">
                <div className="w-full pt-2">
                    <div className=" transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Tableau de board'>
                        <a href={`/${AllRoutes.admin}`} className="px-2 text-white flex">
                            <div>
                                <img src={`logo_plenitude.png`} class={`h-[30px] w-[30px] rounded-[50%]`} />
                            </div>
                        </a>
                    </div>
                    <div className=" transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Tableau de board'>
                        <a href={`/${AllRoutes.admin}`} className="px-2 text-white flex"><TfiDashboard className="h-6 w-6" /></a>
                    </div>
                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Témoignage'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.temoins}`} className="px-2 text-white flex"><MdInsertEmoticon className="h-6 w-6" /> <span className="bg-lime-500 p-1  rounded-3xl translatable">{temoignagelist.length}</span></a>
                    </div>
                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='tout les commentaires'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.commentList}`} className="px-2 text-white flex"><FaComments className="h-6 w-6" /> <span className="bg-lime-500 p-1  rounded-3xl translatable">{commentlist.length}</span></a>
                    </div>
                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Les Activités'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.activity}`} className="px-2 text-white flex"><MdCardTravel className="h-6 w-6 text-white" /></a>
                    </div>
                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Les messages'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.message}`} className="px-2 text-white flex"><BsMessenger className="h-6 w-6" /> <span className="bg-lime-500 p-1  rounded-3xl translatable">{messageslist.length}</span></a>
                    </div>
                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Les email reçus'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.emaillist}`} className="px-2 text-white flex"><MdAlternateEmail className="h-6 w-6" /> <span className="bg-lime-500 p-1  rounded-3xl translatable">{emaillist.length}</span></a>
                    </div>

                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Les Fidèles'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.fildelsList}`} className="px-2 text-white flex  "><FaUserSecret className="h-6 w-6" /> <span className="bg-lime-500 p-1  rounded-3xl translatable">{fidelesList.length}</span></a>
                    </div>

                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Les membres'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.memberlist}`} className="px-2 text-white flex  "><FaUsers className="h-6 w-6" /> <span className="bg-lime-500 p-1  rounded-3xl translatable">{memberslist.length}</span></a>
                    </div>
                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='Les utlistaueurs'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.userlist}`} className="px-2 text-white flex  "><FaRegUserCircle className="h-6 w-6" /> <span className="bg-lime-500 p-1  rounded-3xl translatable">{userlist.length}</span></a>
                    </div>
                    <div className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title='paramètre des pages'>
                        <a href={`/${AllRoutes.admin}/${AllRoutes.contentPage}`} className="px-2 text-white  "><AiFillSetting className="h-6 w-6" /></a>
                    </div>
                    <form className="  hover:bg-gray-600 transition-all ease-linear duration-700 py-1 my-2 flex item-center justify-center" title="Deconnexion "
                        onSubmit={(e) => {
                            e.preventDefault();
                            DiconnectUser(id);
                        }}
                    >
                        <button className="px-2 text-white  "><BiExit className="h-6 w-6" /></button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SidebarAdmin
